/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-14 22:13:22
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./index.css";

class BsyDashboardCustomApp extends Component {
  static defaultProps = {
    customApp: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      customApp: props.customApp,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const customApp = { ...nextProps.customApp };
    this.setState({
      customApp: customApp,
    });
  }

  selectApp = (appinfo) => {
    // console.log('selectApp', appinfo)
    this.props.history.push(`${window.rootDirectroy}/team/app/${appinfo._id}`);
    // if (this.props.onSelectApp) {
    //     this.props.onSelectApp(appinfo)
    // }
  };

  render() {
    const { customApp } = this.state;
    const boxWidth =
      this.props.mode === "edit"
        ? document.querySelector("#bby").clientWidth - 340
        : document.querySelector("#bby").clientWidth - 90;
    const totalMargin = boxWidth % 190;
    const numMargin = totalMargin / parseInt(boxWidth / 190) / 2;
    let ars = [];
    if (customApp.apps) {
      if (Array.isArray(customApp.apps)) {
        ars = customApp.apps;
      } else {
        for (let key in customApp.apps) {
          ars.push(customApp.apps[key]);
        }
      }
    }

    return (
      <div className={"dashboard-custom-app"}>
        <div className="bys-group-box">
          {ars.map((data, index) => {
            return (
              <div
                className="bys-group-box-item "
                style={{ margin: `0 ${numMargin}px 16px` }}
                id={data._id}
                onClick={this.selectApp.bind(this, data, index)}
                key={"box-" + index}
              >
                <div className="view">
                  <div className="app-wrapper">
                    <div className="icon-wrapper">
                      <div
                        className={
                          "icon-backgroup color-cover-" + data.style.color
                        }
                      >
                        <div
                          className={
                            "imgbg-bsy-app imgbg-bsy-app-" + data.style.icon
                          }
                        ></div>
                      </div>
                    </div>
                    <div
                      className="app-title"
                      title={data.appname}
                      id={"app_title_" + data._id}
                    >
                      {data.appname}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withRouter(BsyDashboardCustomApp);
